// extracted by mini-css-extract-plugin
export default {"walletDocker":"walletDocker--HMkMe","operations":"operations--Mcz94","button":"button--uZVNU","icon":"icon--zcN9m","menuButton":"menuButton--PyrZH"};